<template>
	<v-container fluid class="pa-4">
		<v-card flat>
			<v-card-title>I miei progetti</v-card-title>
			<v-divider></v-divider>

			<v-card-text v-if="loading" class="text-center pa-8">
				<v-progress-circular indeterminate color="primary"></v-progress-circular>
			</v-card-text>

			<v-card-text v-else-if="!projects.length" class="text-center pa-12 grey--text">
				<v-icon size="64" color="grey lighten-2">mdi-folder-open-outline</v-icon>
				<div class="text-h6 mt-4">Nessun progetto condiviso</div>
			</v-card-text>

			<v-row v-else class="pa-2">
				<v-col v-for="p in projects" :key="p.id" cols="12" sm="6" md="4">
					<v-card outlined hover @click="open(p)" class="fill-height">
						<v-card-title class="text-subtitle-1 font-weight-bold">{{ p.name }}</v-card-title>
						<v-card-subtitle v-if="p.code">{{ p.code }}</v-card-subtitle>
						<v-card-text>
							<v-chip small color="primary" outlined class="mr-2 mb-1">
								<v-icon left small>mdi-clipboard-text-outline</v-icon>
								{{ p.items_open }} aperte
							</v-chip>
							<v-chip small outlined class="mb-1">{{ p.items_total }} totali</v-chip>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-card>
	</v-container>
</template>

<script>
export default {
	name: 'PortalProjects',
	data() {
		return {
			projects: [],
			loading: false
		}
	},
	created() {
		this.loadProjects()
	},
	methods: {
		async loadProjects() {
			this.loading = true
			try {
				const resp = await this.axios.get('portal/projects')
				if (resp.data.success) {
					this.projects = resp.data.data || []
					// Con un solo progetto si va diretti alle sue segnalazioni
					if (this.projects.length === 1) {
						this.$router.replace('/portal/projects/' + this.projects[0].id)
					}
				}
			} catch (e) {
				// silenzioso
			} finally {
				this.loading = false
			}
		},
		open(p) {
			this.$router.push('/portal/projects/' + p.id)
		}
	}
}
</script>
